import request from '../../config/axiosConfig';
import { GET_LIST_HISTORY_PREMIUMS, CHANGE_HISTORY_PREMIUM_STATUS, LIST_GROUP_SERVICES } from '../../constants/apiEndPoint';

export const getListHistoryPremiumsRequest = async (data) => {
  const result = await request({ url: GET_LIST_HISTORY_PREMIUMS, method: 'POST', data });
  return result?.data?.data;
};

export const changeHistoryPremiumStatusRequest = async (data) => {
  const result = await request({ url: CHANGE_HISTORY_PREMIUM_STATUS, method: 'POST', data });
  return result?.data;
};

export const listPaymentChannelsRequest = async () => {
  const result = await request({ url: '/miniapp/list-payment-channels', method: 'POST' });
  return result?.data?.data;
};

export const listAppVersionsRequest = async () => {
  const result = await request({ url: '/miniapp/list-app-versions', method: 'POST' });
  return result?.data?.data;
};

export const listGroupServicesRequest = async () => {
  const result = await request({ url: LIST_GROUP_SERVICES, method: 'POST' });
  return result?.data?.data;
};
